import React from 'react';
import {
  IconChip, IconDisk, IconMemory, Button,
} from 'gatorcomponents';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import * as Styles from './PlanCard.styles';

const RESOURCE_ICONS = {
  processor: <IconChip color="lowPure" />,
  memory: <IconMemory color="lowPure" />,
  disk: <IconDisk color="lowPure" />,
};

const PlanCard = ({
  plan,
  isCurrent,
  locale,
  isMobile,
  buttonState,
  onSelect,
}) => {
  const resourcesList = plan.resourcesList || [];

  return (
    <Styles.PlanCardWrapper isCurrent={isCurrent} isRecommended={plan.recommended} data-testid={isCurrent ? 'vpsoci-upgrade-listing-current-plan' : `vpsoci-upgrade-listing-plan-${plan.productId}`}>
      {(isCurrent || plan.recommended) && (
        <Styles.PlanCardLabel isCurrent={isCurrent} isRecommended={plan.recommended} data-testid={isCurrent ? undefined : `vpsoci-upgrade-listing-plan-label-${plan.productId}`}>
          {isCurrent && locale.currentPlanLabel}
          {!isCurrent && plan.recommended && locale.recommendedLabel}
        </Styles.PlanCardLabel>
      )}

      <Styles.PlanCardInner
        hasLabel={isCurrent || !!plan.recommended}
        data-testid={isCurrent ? 'vpsoci-upgrade-listing-current-plan-inner' : undefined}
      >
        <Styles.PlanCardTopSection>
          <Styles.PlanCardHeading>
            <Styles.PlanCardName data-testid={isCurrent ? 'vpsoci-upgrade-listing-current-plan-name' : `vpsoci-upgrade-listing-plan-name-${plan.productId}`}>
              {plan.productName}
            </Styles.PlanCardName>
            {!isCurrent && plan.discountPercentage && (
              <Styles.PlanCardDiscountBadge>
                {plan.discountPercentage}
                {' '}
                OFF
              </Styles.PlanCardDiscountBadge>
            )}
          </Styles.PlanCardHeading>

          {(isCurrent && !isMobile) && <Styles.PlanCardPricesPlaceholder aria-hidden="true" />}

          {!isCurrent && plan.monthlyPrice && (
            <Styles.PlanCardPrices data-testid={`vpsoci-upgrade-listing-plan-prices-${plan.productId}`}>
              <Styles.PlanCardMonthlyPriceWrapper>
                <Styles.PlanCardCurrencySymbol>R$</Styles.PlanCardCurrencySymbol>
                <Styles.PlanCardMonthlyPrice data-testid={`vpsoci-upgrade-listing-plan-monthly-price-${plan.productId}`}>
                  {formatCurrency(plan.monthlyPrice).replace('R$ ', '').replace('R$ ', '')}
                </Styles.PlanCardMonthlyPrice>
                <Styles.PlanCardMonthlyPriceSuffix>
                  {locale.prices?.suffixText}
                </Styles.PlanCardMonthlyPriceSuffix>
              </Styles.PlanCardMonthlyPriceWrapper>
              {plan.fullPrice && (
                <Styles.PlanCardFullPrice data-testid={`vpsoci-upgrade-listing-plan-full-price-${plan.productId}`}>
                  {formatCurrency(plan.fullPrice)}
                </Styles.PlanCardFullPrice>
              )}
              <Styles.PlanCardCyclePrice data-testid={`vpsoci-upgrade-listing-plan-cycle-price-${plan.productId}`}>
                {(plan.billingCycle && plan.billingCycle !== 'monthly') && plan.fullPrice && (
                  `${formatCurrency(plan.fullPrice)} ${locale.perCycle?.[plan.billingCycle]}`
                )}
              </Styles.PlanCardCyclePrice>
            </Styles.PlanCardPrices>
          )}
        </Styles.PlanCardTopSection>

        <Styles.PlanCardBottomSection>
          <Styles.PlanCardResourcesList>
            {resourcesList.map(resource => (
              <Styles.PlanCardResourcesItem key={resource.testId} data-testid={isCurrent ? `vpsoci-upgrade-listing-current-plan-resource-${resource.testId}` : `vpsoci-upgrade-listing-plan-resource-${resource.testId}-${plan.productId}`}>
                {RESOURCE_ICONS[resource.testId]}
                <Styles.PlanCardResourcesItemValue>
                  {resource.value}
                </Styles.PlanCardResourcesItemValue>
                {' '}
                <Styles.PlanCardResourcesItemSuffix>
                  {locale.resources?.suffix?.[resource.testId]}
                </Styles.PlanCardResourcesItemSuffix>
                {resource.delta && (
                  <Styles.PlanCardResourceDeltaBadge data-testid={`vpsoci-upgrade-listing-plan-resource-delta-${resource.testId}-${plan.productId}`}>
                    {resource.delta}
                  </Styles.PlanCardResourceDeltaBadge>
                )}
              </Styles.PlanCardResourcesItem>
            ))}
          </Styles.PlanCardResourcesList>

          {(isCurrent && !isMobile) && <Styles.PlanCardButtonPlaceholder aria-hidden="true" />}

          {!isCurrent && (
            <Styles.PlanCardButtonWrapper isRecommended={plan.recommended}>
              <Button
                variant={plan.recommended ? 'secondary' : 'primary'}
                size={isMobile ? 'medium2' : 'large'}
                width="full"
                version="v2"
                onClick={onSelect}
                testId={`vpsoci-upgrade-listing-plan-button-${plan.productId}`}
                label={locale.button}
                {...buttonState}
              />
            </Styles.PlanCardButtonWrapper>
          )}
        </Styles.PlanCardBottomSection>
      </Styles.PlanCardInner>
      {isCurrent && <Styles.CarouselNavSpacer aria-hidden="true" />}
    </Styles.PlanCardWrapper>
  );
};

export default PlanCard;
